import React from 'react';
import TabButton from 'components/TabButton';
import { useTranslation } from 'react-i18next';
const OptionSectionDesktop = ({ status, changeStatus }) => {
  const { t } = useTranslation();

  return (
    <div className='md:max-w-xl hidden md:flex md:gap-1.5 md:px-0 px-6'>
      <TabButton
        text={t('share.generate_link')}
        isActive={status === 'generate'}
        share={true}
        icon='link'
        onClick={() => changeStatus('generate')}
      />
      <TabButton
        text={t('share.snippet')}
        isActive={status === 'snippet'}
        share={true}
        icon='snippet'
        onClick={() => changeStatus('snippet')}
      />
    </div>
  );
};

export default OptionSectionDesktop;
